<template>
    <el-dialog
        :title="dialogMain['title']"
        :visible.sync="dailogShow"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="dialog"
        top="30vh"
        :width="dialogMain['width']">
        <div class="dialog-conten dialogMain" @click.stop="dialogHandle">
            <!-- 新增分组 编辑分组 复制分组-->
            <div class="addGroup" v-if='dialogMain["type"]==0' >
                <el-form label-position="right" label-width="80px" :model="addMessage">
                    <el-form-item label="分组名称">
                        <el-input v-model="addMessage.grounpName" placeholder='请输入' maxlength='8' size='mini'></el-input>
                    </el-form-item>
                    <el-form-item label="所属部门" style="max-height: 400px;overflow: auto">
                        <div v-if="addMessage.libaryGrounp == '1'">
                            <el-tree
                                :data="addMessage.treeData"
                                ref="tree"
                                show-checkbox
                                node-key="id"
                                default-expand-all
                                :default-checked-keys="addMessage.defaultCheckedKeys"
                                class='treeDep'
                                id='treeDemo'
                                :props="addMessage.defaultProps">
                            </el-tree>
                        </div>
                        <div v-else class='partGrounp'>
                            <el-select v-model="firstStage" placeholder="请选择" @change="selectFirstStage">
                                <el-option
                                    v-for="item in firstList"
                                    :key="item.id"
                                    :value="item.groupName">
                                </el-option>
                            </el-select>
                            <el-select :disabled="!secondList.length" v-model="secondStage" placeholder="请选择" @change="selectSecondStage">
                                <el-option value=''>请选择</el-option>
                                <el-option
                                    v-for="item in secondList"
                                    :key="item.id"
                                    :value="item.groupName">
                                </el-option>
                            </el-select>
                            <el-select :disabled="!thirdList.length" v-model="thirdStage" placeholder="请选择" @change="selectThirdStage">
                                <el-option value=''>请选择</el-option>
                                <el-option
                                    v-for="item in thirdList"
                                    :key="item.id"
                                    :value="item.groupName">
                                </el-option>
                            </el-select>
                            <el-select :disabled="!fourList.length" v-model="fourStage" placeholder="请选择" @change="selectfourStage">
                                <el-option value=''>请选择</el-option>
                                <el-option
                                    v-for="item in fourList"
                                    :key="item.id"
                                    :value="item.groupName">
                                </el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 新增话术 -->
            <div class="addSkill" v-if='dialogMain["type"]==1'>
                <el-form label-position="right" label-width="50px">
                    <el-form-item label="分组">
                        <select class="taleDialogSelect" v-model='addMessage.grounpSelectChose' size='mini'>
                            <option :value="item.id" v-for='(item) of addMessage.grounpSelect' :key='item.id'>{{item.name}}</option>
                        </select>
                    </el-form-item>
                    <el-form-item label="标题">
                        <el-input v-model="addMessage.skillTitle" placeholder='请输入' maxlength=10 size='mini'></el-input>
                    </el-form-item>
                    <el-form-item label="类型">
                        <select class="taleDialogSelect" v-model="addMessage.skilType" @change="typeChose" size='mini'>
                            <option value="1">文字</option>
                            <option value="2">图片</option>
                            <option value="3">语音</option>
                            <option value="4">视频</option>
                            <option value="5">文件</option>
                        </select>
                    </el-form-item>
                    <el-form-item label="内容">
                        <!-- 文字 -->
                        <div class='uploadWord' v-show='addMessage.skilType==1'>
                            <div class='contentMainBox'>
                                <textarea class='contentMain' cols="30" rows="100" v-model="addMessage['templateContent']['words']" placeholder='请输入模板内容，最多输入600个字' maxlength=600 ref='addTextarea' @blur="resetpos"></textarea>
                                <a href="javascript:;" class="icon_bq icon_bq_on" @click.stop="oppenexpression"></a>
                            </div>
                            <div class="expressionlist" v-show="showexpression">
                                <!-- 表情 -->
                                <el-scrollbar style="height: 100%;">
                                    <ul>
                                        <li v-for="(item,index) in 282" :key='index' @click="addexpression(index)">
                                            <a href="javascript:;" :class="'intro-'+index" v-if="index<=104"></a>
                                            <a href="javascript:;" :class="'intromoji-'+index" v-else></a>
                                        </li>
                                    </ul>
                                </el-scrollbar>
                            </div>
                        </div>
                        <!-- 图片 -->
                        <div class="uploadImg" v-show='addMessage.skilType==2'>
                            <div class="uploadImgBox">
                                <input type="file" ref="imgHandle" @input.stop='uploadFileBtn' accept=".jpg,.png">
                                <div class='imgCover' v-show='imgUrl'>
                                    <img :src="imgUrl" alt="">
                                    <div class="videoBoxDialog">
                                        <span class='playVideo' @click.stop="lookImg">查看</span>
                                        <span class='replaceVideo' @click='imgReplace'>替换</span>
                                    </div>
                                </div>
                            </div>
                            <div class="imgDes">图片大小不超过5M,仅支持jpg、png</div>
                        </div>
                        <!-- 音频 -->
                        <div class='uploadAudio' v-show='addMessage.skilType==3'>
                            <div v-if="!addMessage.templateContent.yuyin">
                                <div class="uploadAudioBtn">
                                    <span @click.stop='handleclick()' v-if='!audioText'>{{audioText?'点击结束':'点击录制'}} {{this.saveAudioDuration}}</span>
                                    <span @click.stop='handleclickt()' v-else>{{audioText?'点击结束':'点击录制'}} {{this.saveAudioDuration}}</span>
                                    <span class='uploadAudioSend'>上传文件
                                        <input type="file" accept=".mp3" ref='audioHandle' @input.stop='uploadFileBtn'>
                                    </span>
                                </div>
                                <ul class="audioBox yinBox" v-show='audioData.audioProcess'>
                                    <videoPlay bg='' :mp3url='saveAudio'></videoPlay>
                                </ul>
                                <div class="imgDes">语音大小不可超过10MB（长度超过60s会发送失败），录音消息长度超过60s自动截止，仅支持mp3格式</div>
                            </div>
                            <div v-else class='yinBox'>
                                <videoPlay bg='' :mp3url='addMessage.templateContent.yuyin'></videoPlay>
                                <span class="re-record" @click="reRecord">重新录制</span>
                            </div>
                        </div>
                        <!-- 视频 -->
                        <div class="uploadVideo" v-show='addMessage.skilType==4'>
                            <div class="uploadVideoBox" @input.stop='uploadFileBtn'>
                                <input type="file" ref='videoHandle' accept=".mp4">
                                <div class="videoBox" v-show="playerOptions.src!=''">
                                    <video :src="playerOptions.src" controls="controls" ref='videoPlay'></video>
                                    <!-- <div class="videoBoxDialog">
                                        <i class="iconfont playIcon" @click='videoPlay'>&#xe683;</i>
                                        <span class='playVideo' @click='videoPlay'>播放</span>
                                        <span class='replaceVideo' @click='videoReplace'>替换</span>
                                    </div> -->
                                </div>
                            </div>
                            <span class='replaceShi' @click='videoReplace' v-show='shiStatus'>替换</span>
                            <div class="imgDes">视频长度不可超过5分钟，大小限制25M，仅支持mp4格式</div>
                        </div>
                        <!-- 文件 -->
                        <div class='uploadFile' v-show='addMessage.skilType==5'>
                            <div class="uploadAudioBtn">
                                <div class="uploadAudioBtnBox">
                                    <span >上传文件</span>
                                    <input type="file" @input='uploadFileBtn' ref='fileHandle' accept=".doc,.docx,.xlsx,.xlsm,.xlts,.xltm,.xlsb,.xlam,.pdf">
                                </div>
                            </div>
                            <ul class='uploadFileList' v-show='uploadFileSave["uploadFileName"].length'>
                                <li>
                                    <div class="fileIcon filePdf iconfont" v-if="uploadFileSave['uploadFileName'][0]=='pdf'">&#xe733;</div>
                                    <div class="fileIcon fileWord iconfont" v-if="uploadFileSave['uploadFileName'][0]=='doc'||uploadFileSave['uploadFileName'][0]=='docx'">&#xe737;</div>
                                    <div class="fileIcon fileExcel iconfont" v-if="uploadFileSave['uploadFileName'][0]=='xlsx'||uploadFileSave['uploadFileName'][0]=='xls'||uploadFileSave['uploadFileName'][0
                                    ]=='csv'">&#xe732;</div>
                                    <div class="fileMain">
                                        <div class='fileMainName'>
                                            <p class="fileName">{{uploadFileSave["uploadFileName"][1]| ellipsis}}</p>
                                            <p class="fileType">.{{uploadFileSave["uploadFileName"][0]}}</p>
                                        </div>
                                        <p class='fileMainSize'>{{uploadFileSave["uploadFileName"][2]}}KB</p>
                                    </div>
                                </li>
                            </ul>
                            <div class="imgDes">文件大小不超过10M，仅支持word、excel、PDF格式</div>
                        </div>

                    </el-form-item>
                </el-form>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size='mini' @click.stop='addFail'>取 消</el-button>
            <el-button type="primary" size='mini' @click.stop="addSuccess">保 存</el-button>
        </span>
    </el-dialog>
</template>

<script>
let shiSaveDuring='';
let yinSaveDuring='';
// 获取表情json数据
import facedata from '@/utils/face.json';
// 录音
import recorder from '@/views/customerservice/components/recorder'

import base64 from '@/utils/base64.js'
// 上传JS
import uploadfile from '@/utils/upload.js'

// 录音
import Recorder from 'js-audio-recorder'
var recorderFile = new Recorder()

// 播放组件
import videoPlay from '@/components/mp3Play'

// 获取API
import {
        findCompanyGroup,
        insertDiscourseGroup,
        updateDiscourseGroup,
        getDiscourseGroup,
        updateTemplateStatement,
        insertTemplateStatement,
        searchDiscourseGroup
    } from '@/utils/api-im.js'

export default {
    name:'sensitiveSetting-dialog',
    props:{
        dialogMain:{},
        showData:{},
        skillData:{}
    },
    components: {
        recorder,
        videoPlay
    },
    data() {
        return {
            // 视频地址
            playerOptions: {
                src:'', // url地址
                poster:'',//封面地址
                newUrl:false
            },
            dailogShow:false,
            imgUrl:'',
            audioData:{
                audioProcess:false
            },
            saveAudioDuration:0,
            saveAudio:'',//录音地址
            audioText:false,
            // 新增弹窗消息
            addMessage: {
                discourseGroupId:'',//分组id
                libaryGrounp:1,//公共库
                grounpName:'',//分组名称
                grounpType:'',//新增分组--0  编辑分组--1
                grounpSelect:'',//话术下拉框数据
                grounpTotal:'',
                skillTitle:'',//话术标题
                skilType:2,//话术类型
                grounpSelectChose:'',
                treeData: [],
                    // tree绑定
                defaultProps: {
                    children: 'list',
                    label: 'groupName',
                    id: "id"
                },
                defaultCheckedKeys: [],
                grounp:'',
                title:'',
                type:'0',
                //模板内容
                templateContent:{
                    words:'',//文字
                    img:'',//图片
                    yuyin:'',//语音
                }
            },
            showexpression: false, //是否显示表情包
            showRecorder: false,
            // 上传图片
            dialogImageUrl: '',
            // 保存上传的文件
            saveFile:'',
            //存储文件名字 大小 时长
            saveFileMessage:{
                img:{
                    name:'',
                    size:''
                },
                yin:{
                    name:'',
                    size:'',
                    during:''
                },
                shi:{
                    name:'',
                    size:'',
                    during:''
                },
                file:{
                    name:'',
                    size:'',
                    src:''
                },
                name:'',
                src:'',
                size:'',
                during:''
            },
            dialogVisible: false,
            facedata: facedata, //表情数据
            startPos: 0, //光标位置
            endPos: 0, //光标位置
            toolsContent: {
                contentType: 1,
            },
            //存放上传文件的网址
            uploadFileSave:{
                uploadFileName:'',
                uploadFileFile:'',
            },
            depGroupId: "",
            depReationList: [],
            allSelectNodes: [],
            allSelectKeys: [],
            firstStage: "",
            secondStage: "",
            thirdStage: "",
            fourStage:'',
            firstList: [],
            secondList: [],
            thirdList: [],
            fourList:[],
            selectId: [],
            // 保存按钮防止重复点击
            saveBtn:true,
            // 视频替换按钮状态
            shiStatus:false,
            shiDuring:false,
            yinDuring:false,
            // 私有是否换分组
            privateOriginal:''
        }

    },
    filters: {

        // 文件名称过长 中间显示省略号
		ellipsis (value) {
            if(value){
                let len=value.length;
            if (!value) return ''
            if (value.length > 20) {
                return value.substring(0,4) + '......' +value.substring(len-6,len)
            }
            return value
            }
		}
	},
    methods: {
        // 表情框点击白块消失
        dialogHandle(done){
            const [_this] = [this];
            _this.showexpression = false;
        },
        // 格式化 addSuccess depReationList
        formatSelectData(keys, nodes) {
            let depReationList = [];
            for (let i = 0; i < keys.length; i++) {
                let keysItem = keys[i];
                let depGroupId = []
                let keysParentId = "";
                for (var j = nodes.length - 1; j >= 0; j--) {
                    let nodesItem = nodes[j];
                    if (keysItem === nodesItem.id) {
                        depGroupId.unshift(keysItem)
                        keysParentId = nodesItem.parentId
                    }
                    if (keysParentId === nodesItem.id) {
                        depGroupId.unshift(keysParentId)
                        keysParentId = nodesItem.parentId
                    }
                }
                // return false;
                depReationList.push({
                    depGroupId: ','+(depGroupId.join(","))+','
                })
            }
            return depReationList
        },
        // 编辑分组 格式化 defaultCheckedKeys
        formatInitData(depReationList) {
            let selectTreeData = [];
            for (let i = 0; i < depReationList.length; i++) {
                let depReationItem = depReationList[i].depGroupId;
                selectTreeData.push(parseInt(depReationItem.split(",").slice(-2)[0]))
            }
            return selectTreeData
        },
        selectFirstStage(value) {
            this.selectId = this.secondList = [];
            this.thirdList = [];
            this.secondStage = this.thirdStage = "";
            let firstItem = this.firstList.filter(i => i.groupName === value)[0]
            this.selectId.push(firstItem.id);
            this.secondList = firstItem.list;
        },
        selectSecondStage(value) {
            if(value==''){
                this.thirdStage = "";
                this.fourStage = "";
                this.thirdList = [];
                this.fourList = [];
                this.selectId.length = 1;
                return false;
            }
            this.thirdList = [];
            this.fourList = [];
            this.thirdStage = "";
            this.fourStage = "";
            console.log(this.selectId,this.selectId.splice(1))
            this.selectId.splice(1)
            let secondItem = this.secondList.filter(i => i.groupName === value)[0]
            this.selectId.push(secondItem.id);
            if(secondItem.list!=undefined){
                this.thirdList = secondItem.list;
            }
        },
        selectThirdStage(value) {
            if(value==''){
                this.fourList = [];
                this.fourStage = "";
                this.selectId.length = 2;
                return false;
            }
            this.fourStage = "";
            this.fourList = [];
            this.selectId.splice(2)
            let thirdStageId = this.thirdList.filter(i => i.groupName === value)[0];
            this.selectId.push(thirdStageId.id);
            if(thirdStageId.list!=undefined){
                this.fourList = thirdStageId.list;
            }
        },
        selectfourStage(value){
            if(value==''){
                this.selectId.length = 3;
                return false;
            }
            this.selectId.splice(3);
            let fourStageId = this.fourList.filter(i => i.groupName === value)[0];
            this.selectId.push(fourStageId.id);
        },
        // 弹窗保存成功
        addSuccess(){
            let [_this] = [this];
            let [grounpName,type,saveType] = [_this['addMessage']['grounpName'],_this['dialogMain']['type'],_this['addMessage']['grounpType']]
            let depReationList = [];
            if(_this.saveBtn){
                // 修改保存按钮状态
                _this.saveBtn = false;
                switch (parseInt(type)) {
                    case 0:
                        if(parseInt(this.addMessage.libaryGrounp) ===1) {
                            this.allSelectKeys = this.$refs.tree.getCheckedKeys(true);
                            this.allSelectNodes = this.$refs.tree.getCheckedNodes(false, true)
                            depReationList = this.formatSelectData(this.allSelectKeys, this.allSelectNodes)
                            if(depReationList.length==0){
                                _this.$toast('所属部门不能为空！');
                                _this.saveBtn = true;
                                return false;
                            }
                        } else {
                            // 添加公司id
                            depReationList = [{depGroupId: ','+this.selectId.join(",")+','}];
                            if(this.selectId.length==0){
                                _this.$toast('所属部门不能为空！');
                                _this.saveBtn = true;
                                return false;
                            }
                        }
                        let addGrounpData = {
                            "depReationList": depReationList,
                            "name": _this['addMessage']['grounpName'],
                            "type": this['dialogMain']['library']!=''?this['dialogMain']['library']:_this['addMessage']['libaryGrounp']
                        };
                        // 分组
                        if(!grounpName){
                            _this.$toast('请输入分组名称！');
                            _this.saveBtn = true;
                        }else{
                            if(_this['dialogMain']['copy']){
                                _this.$post(insertDiscourseGroup,addGrounpData).then((res)=>{
                                    // 保存按钮不可点击
                                    _this.saveBtn = false;
                                    let dataCode = res['data'];
                                    if(dataCode['code']=='200'){
                                        _this.addFail();
                                        _this['addMessage']['grounpName']='';
                                        _this.$emit('saveSuccess',4)
                                    }else if(dataCode['code']=='-1'){
                                        _this.saveBtn = true;
                                        _this.$toast(dataCode['msg'])
                                    }
                                }).catch(()=>{
                                    this.$toast('保存失败！')
                                    _this.addFail()
                                })
                                return false;
                            }
                            // 添加分组
                            if(saveType==0){
                                _this.$post(insertDiscourseGroup,addGrounpData).then((res)=>{
                                    // 保存按钮不可点击
                                    _this.saveBtn = false;
                                    let dataCode = res['data'];
                                    if(dataCode['code']=='200'){
                                        _this.addFail();
                                        _this['addMessage']['grounpName']='';
                                        _this.$emit('saveSuccess',0)
                                    }else if(dataCode['code']=='-1'){
                                        _this.saveBtn = true;
                                        _this.$toast(dataCode['msg'])
                                    }
                                }).catch(()=>{
                                    this.$toast('保存失败！')
                                    _this.addFail()
                                })
                            }else if(saveType==1){
                                // 编辑分组
                                addGrounpData['id'] = _this['showData']['grouonpData']['id'];
                                // 请求接口
                                _this.$post(updateDiscourseGroup,addGrounpData).then((res)=>{
                                    let dataCode = res['data'];
                                    if(dataCode['code']=='200'){
                                        _this.addFail();
                                        _this['addMessage']['grounpName']='';
                                        _this.$emit('saveSuccess',1)
                                    }else if(dataCode['code']=='-1'){
                                        _this.saveBtn = true;
                                        _this.$toast(dataCode['msg'])
                                    }
                                }).catch(()=>{
                                    this.$toast('编辑失败！')
                                    _this.addFail()
                                })
                            }
                        }
                        break;
                    case 1:
                        // 获取填入的类型内容
                        let templateContent = this['addMessage']['templateContent'];
                        // 获取填入的类型
                        let templateStatementType = _this['addMessage']['skilType'];
                        let data ={
                                discourseGroupType:_this['addMessage']['libaryGrounp'],
                                templateContent:'',
                                discourseGroupId:_this['addMessage']['grounpSelectChose'],
                                templateStatementType,
                                templateTitle:_this['addMessage']['skillTitle'],
                                id: _this['addMessage']['id']
                            }

                        switch (parseInt(templateStatementType)) {
                            case 1:
                                templateContent = templateContent['words'];
                                data.templateContent = templateContent
                                break;
                            default:
                                break;
                        }

                        //话术模板
                        if(!_this['addMessage']['skillTitle']){
                            this.$toast('请输入标题');
                             // 恢复保存按钮点击状态
                            this.saveBtn = true;
                        }else{
                            // 文字
                            if(_this['addMessage']['skilType']==1){
                                if(templateContent==''){
                                    _this.$toast('请输入内容');
                                    // 恢复保存按钮点击状态
                                    this.saveBtn = true;
                                }else{
                                    data['templateContent'] = templateContent;
                                }
                                // 新增话术提交
                                if(saveType==3){
                                    if(data.hasOwnProperty('id')){
                                        delete data['id'];
                                    }
                                    this.$post(insertTemplateStatement,data).then((res)=>{
                                        if(res['data']['code']==200){
                                            _this.addFail();
                                            _this.$emit('saveSuccess',2)
                                        }else{
                                            this.$toast(res['data']['msg'])
                                        }
                                    }).catch(()=>{
                                        this.$toast('新增失败！')
                                        _this.addFail()
                                    })
                                } else {
                                    // 修改话术提交
                                    this.$post(updateTemplateStatement,data).then((res)=>{
                                        if(res['data']['code']==200){
                                            _this.addFail();
                                            if(this.addMessage.libaryGrounp==3){
                                                _this.$emit('saveSuccess', 3,this['addMessage']['grounpSelectChose']==this['privateOriginal'])
                                                return false;
                                            }
                                            _this.$emit('saveSuccess', 3)
                                        }else{
                                            this.$toast('编辑失败！')
                                        }
                                    }).catch(()=>{
                                        this.$toast('编辑失败！')
                                    })
                                }
                            }else{
                                // 上传阿里云(图片 音频 视频 文件提交)
                                _this.uploadSend(this.saveFile, data, saveType)
                            }
                        }
                        break;

                    default:
                        break;
                }
            }else{
                return false;
            }
        },
        imgReplace() {
            this.$refs.imgHandle.click();
        },
        // 开始录音
        handleclick(){
            navigator.getUserMedia  = navigator.getUserMedia ||
                        navigator.webkitGetUserMedia ||
                        navigator.mozGetUserMedia ||
                        navigator.msGetUserMedia;
            if (navigator.getUserMedia) {
                // 支持
                console.log('支持')
                recorderFile.start()// 开始录音
                this.audioText = true;
            } else {
                // 不支持
                console.log('不支持')
                this.$message.error('无法录音：无权录音(需https)');
                return false;
            }
            navigator.getUserMedia({audio:true}, function onSuccess(stream) {
                console.log('已点击允许,开启成功');
            }, function onError(error) {
                console.log("错误：", error);
            });
        },
        handleclickt () {
            recorderFile.stop() // 结束录音
            this.audioText = false;
            this.playAudio();
            if(this.saveAudioDuration>0){
                this.audioData.audioProcess = true;
            }
        },
        handleclickb () {
            const [_this] = [this];
            let timer = '';
            // recorderFile.play() // 录音播放
            Recorder.playAudio(recorderFile.getWAVBlob());
            setInterval(()=>{
                if(_this['saveAudioDuration']==0){
                    clearInterval(timer)
                    return false;
                }else{
                    _this['saveAudioDuration'] = _this['saveAudioDuration'] -1;
                }
            },1000)
        },


        // 音频播放
        playAudio(){
            this.saveAudio = recorderFile.getWAVBlob();
            var reader=new FileReader();
            reader.onloadend= () => {
                let uid = uploadfile.generateUUID()
                let file = uploadfile.dataURItoFile(reader.result,'audio/mp3',uid+'.mp3')
                this.saveFile = file;
                uploadfile.filesToBlob(file).then((data)=>{
                    this.saveAudio=URL.createObjectURL(data.url);;
                })
            };
            let mpType = reader.readAsDataURL(this.saveAudio);
        },
        // 重新录制
        reRecord() {
            this.addMessage.templateContent = {}
        },
        // 点击视频播放
        videoPlay(){
            const [_this] = [this];
            // 播放视频
            _this.$refs.videoPlay.play();
        },
        // 点击替换视频
        videoReplace(){
            const [_this] = [this];
            // 替换视频
            _this.$refs.videoHandle.click();
            _this['playerOptions']['newUrl'] = true;
        },
        // 上传文件
        uploadFileBtn(e) {
            const [_this,upFile] = [this,e.target.files[0]];
            // 保存上传的文件
            _this.saveFile = upFile;
            let fileSize = upFile.size/1024/1024;
            // 图片
            if(_this.addMessage.skilType==2){
                this.$refs.imgHandle.value='';
                if(fileSize>5){
                    _this.$toast('所选文件大于5M');
                    this.$refs.imgHandle.value='';
                    return false;
                }else{
                    uploadfile.filesToBlob(upFile).then((data)=>{
                        this.imgUrl=URL.createObjectURL(data.url);
                        // 赋值文件大小
                        _this['saveFileMessage']['size']=upFile['size'];
                        _this['saveFileMessage']['name']=upFile['name'];
                    })
                }
            }
            // 音频
            if(_this.addMessage.skilType==3){
                _this.$refs.audioHandle.value='';
                this.saveAudio='';
                if(fileSize>20){
                    _this.$toast('所选文件大于10M');
                    this.$refs.audioHandle.value='';
                    return false;
                }else{
                    let url = URL.createObjectURL(upFile);
                    var audioElement = new Audio(url);
                    var duration;
                    audioElement.addEventListener("loadedmetadata", function (_event) {
                        duration = audioElement.duration;
                        if(duration>60){
                            _this.$toast('上传音频文件超过60s，请重新上传！');
                            _this.$refs.audioHandle.value='';
                            _this.yinDuring = true;
                            return false;
                        }else{
                            uploadfile.filesToBlob(upFile).then((data)=>{
                                _this.saveAudio=URL.createObjectURL(data.url);
                                _this.audioData.audioProcess=true;
                                // 赋值文件大小
                                _this['saveFileMessage']['size']=upFile['size'];
                                _this['saveFileMessage']['name']=upFile['name'];
                                _this['saveFileMessage']['during']=Math.floor(duration*1000);
                            })
                        }
                    });
                }
            }
            // 视频
            if(_this.addMessage.skilType==4){
                this.$refs.videoHandle.value='';
                let url = URL.createObjectURL(upFile);
                var audioElement = new Audio(url);
                var duration;
                if(fileSize>25){
                    _this.$toast('所选文件大于25M');
                    this.$refs.videoHandle.value='';
                    return false;
                }else{
                    audioElement.addEventListener("loadedmetadata", function (_event) {
                        duration = audioElement.duration;
                        if(duration>300){
                            _this.$refs.videoHandle.value='';
                            _this.$toast('上传视频文件超过5分钟，请重新上传！');
                            _this.shiDuring = true;
                            return false;
                        }else{
                            uploadfile.filesToBlob(upFile).then((data)=>{
                                _this.playerOptions.src=URL.createObjectURL(data.url);
                                _this.shiStatus = true;
                                // 赋值文件大小
                                _this['saveFileMessage']['size']=upFile['size'];
                                _this['saveFileMessage']['name']=upFile['name'];
                                _this['saveFileMessage']['during']=duration;
                            })
                        }
                    });
                }
            }
            // 文件
            if(_this.addMessage.skilType==5){
                this.$refs.fileHandle.value='';
                if(fileSize>10){
                    _this.$toast('所选文件大于10M');
                    this.$refs.fileHandle.value='';
                    return false;
                }else{
                    let [upFileName,upFileSize] = [upFile['name'].split('.'),upFile['size']];
                    // 存文件名称
                    _this['uploadFileSave']['uploadFileName']=[upFileName[1],upFileName[0],upFileSize];
                    _this['uploadFileSave']['uploadFileFile']=upFile;
                    // 赋值文件大小
                    _this['saveFileMessage']['size']=upFileSize;
                    _this['saveFileMessage']['name']=upFileName;
                    }
            }
            // return false;
        },
        uploadSend(file,item, type){
            let _this = this;
            if(this['addMessage']['skilType']==2){
                if(file==''){
                    if(this.imgUrl==''){
                        this.$toast('请上传图片');
                        this.saveBtn = true;
                        return false;
                    }else{
                        item.fileSize = _this['saveFileMessage']['size'];
                        item.fileName = _this['saveFileMessage']['name'];
                        item.templateContent = this.imgUrl;
                        this.saveaddEdit(type,item);
                        return false;
                    }
                }
            }else if(this['addMessage']['skilType']==3){
                if(file==''){
                    if(this.addMessage.templateContent.yuyin==''){
                        this.$toast('请上传语音');
                        this.saveBtn = true;
                        return false;
                    }else{
                        item.fileSize = _this['saveFileMessage']['size'];
                        item.fileName = _this['saveFileMessage']['name'];
                        item.during = _this['saveFileMessage']['during'];
                        item.templateContent = this.addMessage.templateContent.yuyin;
                        this.saveaddEdit(type,item);
                        return false;
                    }
                }
            }else if(this['addMessage']['skilType']==4){
                if(file==''){
                    if(this.playerOptions.src==''){
                        this.$toast('请上传视频')
                        this.saveBtn = true;
                        return false;
                    }else{
                        item.fileSize = _this['saveFileMessage']['size'];
                        item.fileName = _this['saveFileMessage']['name'];
                        item.during = _this['saveFileMessage']['during'];
                        item.templateContent = this.playerOptions.src;
                        this.saveaddEdit(type,item);
                        return false;
                    }
                }
            }else if(this['addMessage']['skilType']==5){
                if(file==''){
                    if(this.uploadFileSave["uploadFileName"].length!=0){
                        item.templateContent = this.saveFileMessage.file.src;
                        item.fileSize = _this['saveFileMessage']['size'];
                        item.fileName = _this['saveFileMessage']['name'];
                        this.saveaddEdit(type,item);
                    }else{
                        this.$toast('请上传文件')
                        this.saveBtn = true;
                        return false;
                    }
                }
            }
            let filesize =_this['saveFileMessage']['size'];
            if(filesize>1024){
                filesize=filesize/1024
                filesize = filesize.toFixed(1) + 'kb'
            }else if(filesize/1024>1024){
                filesize = filesize/1024/1024
                filesize = filesize.toFixed(1) + 'mb'
            }else{
                filesize = filesize+'b'
            }
            item.fileSize=filesize;

            if(this['addMessage']['skilType']==5){
                item.fileName = file['name'];
            }else{
                item.fileName = this['saveFileMessage']['name'];
            }

            item.duration=this['saveFileMessage']['during'];
            //校验
            uploadfile.upload(file).then(data => {
                //获取oss
                uploadfile.getossbase(data.file,true).then(osdata => {
                    //上传
                    uploadfile.uploadform(osdata).then(updata => {
                        //成功回调
                        this.uploadSuccess(updata, osdata.fileidlist,item, type)
                    })
                })
            })
        },
        uploadSuccess(data, fileidlist,item, saveType) {
            let _this = this;
            let {
                uuid
            } = data
            let filecon = fileidlist[uuid].host + fileidlist[uuid].filename
            // 赋值网址
            item.templateContent = filecon;
            this.saveaddEdit(saveType,item);
            return false;
        },
        saveaddEdit(saveType,item){
            // 上传文件时保存文件大小
            if(saveType==3){
                if(item.hasOwnProperty('id')){
                    delete item['id'];
                }
                this.$post(insertTemplateStatement,item).then((res)=>{
                    if(res['data']['code']==200){
                        this.addFail();
                        this.$emit('saveSuccess',2)
                    }else if(res['data']['code']=='-1'){
                        this.$toast(res['data']['msg']);
                        this.saveBtn = true;
                    }
                }).catch(()=>{
                    this.$toast('保存失败')
                })
            } else {
                this.$post(updateTemplateStatement,item).then((res)=>{
                    if(res['data']['code']==200){
                        this.addFail();
                        this.$emit('saveSuccess', 3)
                    }else if(res['data']['code']=='-1'){
                        this.$toast(res['data']['msg']);
                        this.saveBtn = true;
                    }
                }).catch(()=>{
                    this.$toast('编辑失败')
                })
            }
        },
        // 新增弹窗消失
        addFail(){
            const _this = this;
            _this.dailogShow = false;
            if(_this['dialogMain']['type']==1){
                _this.closeHandle();
            }
        },
        closeHandle(){
            const _this = this;
            _this['addMessage']['grounpType'] = '';
            // 保存按钮可点击
            _this.saveBtn = true;
            // 清除图片
            _this.imgUrl = '';
            //  清除上传的文件
            _this.saveFile='';
            //清除上传的音频
            _this.saveAudio='';
            _this.audioData['audioProcess']=false;
            _this.audioText = false;
            _this.saveAudioDuration=0;
        },
        // 新增分组类型选择
        typeChose(){
            // 清除其他选项
            let type = parseInt(this.addMessage.skilType);
            switch (type) {
                case 1:
                    this.$refs.imgHandle.value='';
                    this.$refs.audioHandle.value='';
                    this.$refs.videoHandle.value='';
                    this.$refs.fileHandle.value='';
                    this.addMessage.templateContent.words=''
                    this.imgUrl ='';
                    this.addMessage.templateContent.yuyin = '';
                    this.playerOptions.src='';
                    this['uploadFileSave']['uploadFileName']=[]
                    break;
                case 2:
                    this.$refs.audioHandle.value='';
                    this.$refs.videoHandle.value='';
                    this.$refs.fileHandle.value='';
                    this.addMessage.templateContent.words=''
                    this.imgUrl ='';
                    this.addMessage.templateContent.yuyin = '';
                    this.playerOptions.src='';
                    this['uploadFileSave']['uploadFileName']=[]
                    break;
                case 3:
                    this.$refs.imgHandle.value='';
                    this.$refs.videoHandle.value='';
                    this.$refs.fileHandle.value='';
                    this.addMessage.templateContent.words=''
                    this.imgUrl ='';
                    this.addMessage.templateContent.yuyin = '';
                    this.playerOptions.src='';
                    this['uploadFileSave']['uploadFileName']=[]
                    break;
                case 4:
                    this.$refs.imgHandle.value='';
                    this.$refs.audioHandle.value='';
                    this.$refs.fileHandle.value='';
                    this.addMessage.templateContent.words=''
                    this.imgUrl ='';
                    this.addMessage.templateContent.yuyin = '';
                    this.playerOptions.src='';
                    this['uploadFileSave']['uploadFileName']=[]
                    break;
                case 5:
                    this.$refs.imgHandle.value='';
                    this.$refs.audioHandle.value='';
                    this.$refs.videoHandle.value='';
                    this.addMessage.templateContent.words=''
                    this.imgUrl ='';
                    this.addMessage.templateContent.yuyin = '';
                    this.playerOptions.src='';
                    this['uploadFileSave']['uploadFileName']=[]
                    break;
                default:
                    break;
            }
        },
        // 删除上传图片
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        // 查看上传图片
        lookImg(file) {
            // this.dialogVisible = true;
            this.$alert(`<img width="100%" src=${this.imgUrl} alt="" id='lookImg' class='dialogImgBox'>`, '预览图片', {
                dangerouslyUseHTMLString: true
            });
        },
        // 图片上传成功
        handleAvatarSuccess(res, file) {
            console.log(res,file)
            // this.imageUrl = URL.createObjectURL(file.raw);
        },
        //显示表情包
        oppenexpression() {
            // this.showRecorder = true
            // 显示表情框
            this.showexpression = !this.showexpression

        },
        closeRecorder() {
            this.showRecorder = false
        },
        // 选择表情
        selectExpression(val) {
            this.showexpression = false
            let rm = this.facedata.expressionMap[val]
            let qqList = [113, 114, 115, 116, 117, 118, 124, 125]
            // qq表情
            if (rm) {
                if (val < 105 || qqList.indexOf(val) >= 0) {
                    rm = '[' + this.facedata.expressionMap[val] + ']'
                } else {
                    rm = '<' + rm + '>'
                    rm = this.facedata.emojiMap[rm]
                    // let en = '😁'
                    // let encode = en.codePointAt(0)
                    let rmencode = parseInt(rm, 16)
                    rm = String.fromCodePoint(rmencode)
                }
                return rm
            } else {
                return ''
            }
        },
        // 输入表情
        addexpression(index) {debugger
            if(this.addMessage['templateContent']['words'].length==600){
                return false;
            }
            let face = this.selectExpression(index)
            const value = this['addMessage']['templateContent']['words'];
            const newValue = // 拼接
                value.substring(0, this.startPos) +
                face +
                value.substring(this.endPos, value.length)
            this['addMessage']['templateContent']['words'] = newValue
            // 重置光标位置紧跟在表情文本后面
            let el = this.$refs.addTextarea;
            if (el.setSelectionRange) {
                setTimeout(() => {
                    const index = this.startPos + face.length
                    el.setSelectionRange(index, index)
                    el.focus()
                }, 0)
            }
            this.toolsContent.contentType = 1
        },
        // 记录光标位置
        resetpos() {debugger
            let elInput = this.$refs.addTextarea;
            let startPos = elInput.selectionStart;
            let endPos = elInput.selectionEnd;
            this.startPos = startPos;
            this.endPos = endPos;
        },
        // 新增分组
        // 获取组织机构数据
        getOrganization(){
            const [_this] = [this];
            this.$post(findCompanyGroup,{}).then((res)=>{
                if(res.data.code === 200) {
                    this.addMessage.treeData =  res.data.data ? res.data.data : []
                }
            })
        },
        // 获取分组下拉列表
        getGrounpList(){
            const [_this] = [this];
            if(this.addMessage.libaryGrounp=='3'){
                let data = {
                    type:this.addMessage.libaryGrounp,
                    current:1
                }
                this.$post(searchDiscourseGroup,data).then((res)=>{
                    const [data] = [res['data']['data']];
                    // 赋值数据
                    _this['addMessage']['grounpSelect'] = data['records'];
                    // 选中第一个
                    if(this['addMessage']['grounpType']==3){
                        _this.addMessage.grounpSelectChose = data['records'][0]['id']
                    }
                })
            }else{
                let grounpPart = {
                    "current":1,
                    "size": _this['addMessage']['grounpTotal'],
                    "type": this['dialogMain']['library']!=''?this['dialogMain']['library']:_this['addMessage']['libaryGrounp']
                }
                this.$post(getDiscourseGroup,grounpPart).then((res)=>{
                    const [data] = [res['data']['data']];
                    // 赋值数据
                    _this['addMessage']['grounpSelect'] = data['records'];
                    if(this['addMessage']['grounpType']==3){
                        _this.addMessage.grounpSelectChose = data['records'][0]['id']
                    }
                })
            }
        },
    },
    watch: {
        dialogMain:{
            handler(newValue, oldValue) {
                this['addMessage']['libaryGrounp'] = newValue.library;
                if(newValue['type']==1){
                     // 获取分组数据
                    this.getGrounpList();
                    this.saveFileMessage={
                        img:{
                            name:'',
                            size:''
                        },
                        yin:{
                            name:'',
                            size:'',
                            during:''
                        },
                        shi:{
                            name:'',
                            size:'',
                            during:''
                        },
                        file:{
                            name:'',
                            size:''
                        },
                        name:'',
                        size:'',
                        during:''
                    };
                }
                this.shiStatus = false;
                this.saveBtn = true;
                // 清除弹窗里边状态
                this.closeHandle();
                // 弹窗展示
                this.dailogShow = newValue['talkDialogVisible'];
                // 展示话术内容类型
                this.addMessage.type = newValue.type;
                // 表情弹窗消失
                this.showexpression = false;
    　　　　},
    　　　　deep: true
        },
        showData:{
            handler(newValue, oldValue) {
                const _this = this;
                this['addMessage']['grounpSelectChose'] = newValue['grounpId'];
                this['addMessage']['grounpType'] = newValue['grounpType'];
                // 添加分组
                if(newValue.grounpType === 0) {
                    // 赋值数据
                    this['addMessage']['grounpName'] = "";
				    console.log(this.addMessage)
                    this.addMessage.defaultCheckedKeys = [this.addMessage.treeData[0].id];
                    // 清除部门
                    this.firstList = [];
                    this.secondList = [];
                    this.thirdList = [];
                    this.fourList = [];
                    this.firstStage ='';
                    this.secondStage ='';
                    this.thirdStage = '';
                    this.fourStage = '';
                }
                // 编辑分组
                if(newValue['grounpType'] == 1){
                    // 赋值数据
                    // this.getOrganization();
                    this['addMessage']['grounpName'] = newValue['grouonpData']['name'];

                    if(parseInt(_this['addMessage']['libaryGrounp'])=='1'){
                        this.$refs.tree && this.$refs.tree.setCheckedNodes([]);
                        this.addMessage.defaultCheckedKeys = []
                        this.addMessage.defaultCheckedKeys = JSON.parse(JSON.stringify(this.formatInitData(newValue.grouonpData.depReationList)))
                    } else if(parseInt(_this['addMessage']['libaryGrounp'])=='2'){
                        this.firstList = [];
                        this.secondList = [];
                        this.thirdList = [];
                        this.fourList = [];
                        this.firstStage ='';
                        this.secondStage ='';
                        this.thirdStage = '';
                        this.fourStage = '';
                        // 赋值
                        // 清空数据
                        // this.addMessage.treeData=[];
                        this.addMessage.defaultCheckedKeys = [this.addMessage.treeData[0].id];
                        let partArr = this.addMessage.treeData;
                        let partrr = newValue.grouonpData.depReationList[0].depGroupId;
                        partrr = partrr.substring(1, partrr.length-1);
                        let chosePart = partrr.split(',').slice(0);
                        this.selectId= chosePart;
                        for(let i=0;i<partArr.length;i++){
                            if(chosePart[0]==partArr[i].id){
                                // 一级赋值
                                this.firstStage = partArr[i]['groupName'];
                                for(let j=0;j<partArr[i]['list'].length;j++){
                                    this.firstList = partArr[i]['list'][j]['groupName'];
                                    this.secondList = partArr[i]['list'];
                                    if(chosePart[1]==partArr[i]['list'][j]['id']){
                                        // 二级赋值
                                        this.secondStage = partArr[i]['list'][j]['groupName'];
                                        if(partArr[i]['list'][j]['list']){
                                            for(let k=0;k<partArr[i]['list'][j]['list'].length;k++){
                                                this.thirdList = partArr[i]['list'][j]['list'];
                                                if(chosePart[2]==partArr[i]['list'][j]['list'][k]['id']){
                                                    // 二级赋值
                                                    this.thirdStage = partArr[i]['list'][j]['list'][k]['groupName'];
                                                    if(partArr[i]['list'][j]['list'][k]['list']){
                                                        this.fourList =partArr[i]['list'][j]['list'][k]['list'];
                                                        for(let u=0;u<partArr[i]['list'][j]['list'][k]['list'].length;u++){
                                                            if(chosePart[3]==partArr[i]['list'][j]['list'][k]['list'][u]['id']){
                                                                // 四级赋值
                                                                this.fourStage = partArr[i]['list'][j]['list'][k]['list'][u]['groupName'];
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }

                                    }
                                }
                            }
                        }
                    }
                }
                // 添加话术模板
                if(newValue.grounpType == 3) {
                    // 锚点
                    this.addMessage.skillTitle = "";
                    this.addMessage.skilType = 1;
                    this.addMessage.templateContent = {
                        words:'',//文字
                        img:'',//图片
                        yuyin:''//语音
                    }
                    // 视频
                    this.playerOptions={
                        src:'', // url地址
                        poster:'',//封面地址
                        newUrl:false
                    },
                    // 文件
                    this.uploadFileSave={
                        uploadFileName:'',
                        uploadFileFile:'',
                    };
                }
                // 编辑话术模板
                if(newValue['grounpType']==4){
                    // 赋值公共库 部门库 私有库分组选中
                    this['addMessage']['grounpSelectChose'] = newValue['grouonpData']['discourseGroupId'];
                    // 私有库分组选中
                    this['privateOriginal'] = newValue['grouonpData']['discourseGroupId'];
                    // 赋值话术标题
                    this['addMessage']['skillTitle'] = newValue['grouonpData']['templateTitle'];
                    this['addMessage']['id'] = newValue['grouonpData']['id'];
                    this.addMessage.skilType = newValue['grouonpData']['templateStatementType'];
                    // 文件名城赋值
                    if(newValue['grouonpData'].hasOwnProperty('fileName')){
                        this.saveFileMessage.name=newValue['grouonpData']['fileName'];
                    }
                    // 时长赋值
                    if(newValue['grouonpData'].hasOwnProperty('duration')){
                        this.saveFileMessage.during=newValue['grouonpData']['duration'];
                    }
                    // 文件大小赋值
                    if(newValue['grouonpData'].hasOwnProperty('fileSize')){
                        this.saveFileMessage.size=newValue['grouonpData']['fileSize'];
                    }
                    // 文件内容赋值
                    if(this.addMessage.skilType == 1) {
                        this.addMessage.templateContent.words = newValue['grouonpData']['templateContent'];
                    } else if(this.addMessage.skilType == 2) {
                        // 赋值图片名称
                        this.imgUrl = newValue['grouonpData']['templateContent'];
                    } else if(this.addMessage.skilType == 3) {
                        this.addMessage.templateContent.yuyin = newValue['grouonpData']['templateContent'];
                    }else if(this.addMessage.skilType == 4) {
                        this.playerOptions.src=newValue['grouonpData']['templateContent'];
                        this.shiStatus = true;
                    }else if(this.addMessage.skilType == 5) {
                        let fileName = newValue['grouonpData']['fileName'].split('.')
                        _this['uploadFileSave']['uploadFileName']=[fileName[1],fileName[0],newValue['grouonpData']['fileSize']];
                    } else {
                        this.addMessage.templateContent = newValue['grouonpData']['templateContent'];
                    }
                }
                if(this.addMessage.libaryGrounp === "2") {
                    this.firstList = this.addMessage.treeData;
                }
    　　　　},
    　　　　deep: true
        },
        skillData:{
            handler(newValue, oldValue){
                const [_this] = [this];
                _this['addMessage']['grounpTotal'] = newValue;
            },
            deep:true
        }
    },
    mounted() {
        const _this = this;
        recorderFile.onprogress = function(params) {
            _this.saveAudioDuration = Math.floor(params.duration)
            // 录音60秒自动结束
            if(_this.saveAudioDuration==60){
                _this.handleclickt();
            }
            // 赋值录音时长
            _this['saveFileMessage']['during'] = Math.floor(params.duration*1000);
            _this['saveFileMessage']['size'] = params.fileSize;
        }
        this.dialogMain.dialogData = this.addMessage;
        this.getOrganization();
    },
}
</script>
<style lang="less" scoped>
.expressionlist {
    position: absolute;
    bottom: 30px;
    background: #fff;
    padding: 10px;
    height: 180px;

    li {
        width: 20px;
        height: 20px;
        margin: 8px;
        float: left;

        a {
            width: 24px;
            height: 20px;
            background: url(/static/img/qqface.png) -4px -4px no-repeat;
        }

        img {
            width: 24px;
            height: 24px;
        }

        /* 表情*/
        .intro-loop(105);

        .intro-loop(@n, @i: 1) when (@i <=@n) {
            .intro-@{i} {
                background-position: -4px + -29px * mod(@i , 15) -4px + -29px *floor(@i / 15);
            }

            .intro-loop(@n, (@i + 1))
        }

        .intromoji-loop(284);

        .intromoji-loop(@n, @i: 105) when (@i <=@n ) {
            .intromoji-@{i} {
                background: url(/static/img/emoji.png) no-repeat;
                background-size: 434px auto;
                background-position: 1px+ -29px * mod(@i , 15) 202px + -29px *floor(@i / 15);
            }

            .intromoji-loop(@n, (@i + 1))
        }

    }
}
</style>
<style lang="stylus">
.el-select-dropdown__list
    max-width 334px!important
// 新增话术
.addSkill
    height 400px
    overflow-y auto
    .el-form-item
        margin-bottom 10px!important
    .el-input__inner
        width 260px!important
        height 32px!important
</style>
<style lang="stylus" scoped>
.dialogImgBox
    #lookImg
        width 400px
        height auto
        display block
        margin 0 auto
        padding 20px 0

.uploadAudio
    .re-record
        cursor: pointer
        color: #0078ff
.dialog
    .uploadWord
        .el-textarea__inner
            // 文字
            width 658px
            height 220px

</style>
<style lang='stylus' scoped>
.dialogMain
    /deep/ .el-input__inner
        color #000
// 添加分组
.addGroup
	height 400px
    min-height calc(100% - 100px)
    /deep/ .el-input__inner
        width 200px
    .treeDep
        /deep/ &.el-tree
            margin-top 4px
    /deep/ .el-form-item
        margin-bottom 10px



.taleDialogSelect
    width 260px
    height 32px
    border 1px solid #DCDFE6
    border-radius 3px
// 照片文件大小描述
.imgDes
    color #93999F
    font-size 12px
.contentMainBox
    height 220px
    border 1px solid #DADEE0
    border-radius 3px
    .icon_bq_on {
        display:block;
        margin-left 10px
        width: 16px;
        height: 16px;
        vertical-align: middle;
        color: #93999F;
        background: url(/static/img/icon_bq_on.png) center no-repeat;
        background-size: 100% 100%;
    }
    //表情
    .contentMain
        width 100%
        padding 10px
        box-sizing border-box
        border none
        resize none
        padding-bottom 0
        height 175px
        outline none
        line-height 20px
.uploadAudioBtn
    .uploadAudioBtnBox
        position relative
        width 70px
        height h=25px
        line-height h
        text-align center
        border 1px solid #0099FF
        border-radius 3px
        color #0099FF
        margin-top 5px
        span.btn
            padding 5px 10px
            color #0099FF
            border 1px solid #0099FF
            border-radius 3px
            font-size 12px
            margin-right 10px
        input[type=file]
            width 70px
            height 25px
            position absolute
            top 0
            left 0
            right 0
            bottom 0
            opacity 0
            cursor pointer
            font-size 0
.uploadImg
    overflow hidden
    /deep/ .el-dialog__wrapper
        z-index 2
    .uploadImgBox
        width 100px
        height 100px
        border 1px dashed #DADEE0
        border-radius 3px
        position relative
        overflow hidden
        &:after
            content '\e68c'
            font-family "iconfont" !important
            font-size 36px
            color #B5B9BC
            position absolute
            top 25px
            left 32px
        input[type='file']
            position absolute
            width 100px
            height 100px
            opacity 0
            z-index 1
            cursor pointer
            font-size 0
        .imgCover
            img
                position relative
                z-index 1
                display block
                width 100%
                vertical-align middle
                object-fit cover
            .videoBoxDialog
                position absolute
                width 100px
                height 100px
                background rgba(0,0,0,.7)
                top 0
                color #fff
                padding-top 36px
                box-sizing border-box
                text-align center
                z-index 1
                display none
                span
                    cursor pointer
        &:hover
            .videoBoxDialog
                display block

.uploadAudio
    .uploadAudioBtn
        span
            padding 5px 10px
            color #09f
            border 1px solid #09f
            border-radius 3px
            font-size 12px
            margin-right 10px
            position relative
            overflow hidden
            cursor pointer
            &.uploadAudioSend
                input[type='file']
                    position absolute
                    width 70px
                    height 28px
                    top 0
                    left 0
                    opacity 0
                    cursor pointer
                    font-size 0

.uploadVideo
    width 100%
    height auto
    overflow hidden
    .replaceShi
        position absolute
        left 268px
        top 115px
        cursor pointer
        color #0af
    // 播放视频
    .uploadVideoBox
        width 260px
        height 146px
        border 1px dashed #DADEE0
        border-radius 3px
        position relative
        &:after
            content '\e68c'
            font-family "iconfont" !important
            font-size 36px
            color #B5B9BC
            position absolute
            top 48px
            left 112px
        input[type='file']
            position absolute
            width 260px
            height 146px
            opacity 0
            z-index 1
            cursor pointer
            font-size 0
        .videoBox
            position absolute
            width 260px
            height 146px
            z-index 1
            video
                width 100%
                height 100%
            .videoBoxDialog
                position absolute
                width 260px
                height 146px
                background rgba(0,0,0,.7)
                top 0
                color #fff
                padding-top 68px
                box-sizing border-box
                text-align center
                display none
                .playIcon
                    font-size 42px
                    color #fff
                    position absolute
                    top 30px
                    left 108px
                    cursor pointer
                span
                    cursor pointer
            // &:hover
            //     .videoBoxDialog
            //         display block
.uploadFile
    .uploadFileList
        margin-top 15px
        li
            width 310px
            height 68px
            background #F3F6F9
            border-radius 3px
            box-sizing border-box
            padding 12px 14px 0
            margin-bottom 10px
            .fileIcon
                width 34px
                height 40px
                float left
                margin-right 10px
                font-size:36px
                &.filePdf
                    color #FF8A76
                &.fileExcel
                    color #5ACC9B
                &.fileWord
                    color #5DACFF
            .fileMain
                width 220px
                height 42px
                float left
                font-size 12px
                line-height 2
                .fileMainName
                    width 185px
                    height 20px
                    line-height 1
                    overflow hidden
                    color #2a2a2a
                    .fileName
                        width auto
                        height 30px
                        float left
                    .fileType
                        float left
                .fileMainSize
                    color #93999F
        &:last-child
            margin-bottom 0px
#lookImg
    position relative
    z-index 200
// 部门分组部门
.partGrounp
    /deep/ .el-select
        display block
        width 200px
        /deep/ .el-input__inner
            height h=28px
            line-height 28px



</style>



// WEBPACK FOOTER //
// src/components/publicDialog.vue